<template>
	<div class="header_container">

	</div>
</template>
<script>
	import {
		mapState,
		mapMutations
	} from "vuex";
	export default {
		computed: {},
		methods: {

		},
	}
</script>
<style lang="less">
	.header_container {
		height: 80px;
		background-color: #ffffff;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
</style>
